import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { schemas } from '@nandosaus/constants';
import React from 'react';

import { Alert } from '../../alert';
import { Box, Flex } from '../../grid';
import { Button } from '../../button/new';
import { FormikTextInput } from '../../input';
import { Icon } from '../../icons';
import { Modal } from '../../modal/new';
import { P } from '../../typography/new';

const ValidateStreetNumber = ({ saveStreetNumber, handleBack, handleClose, address, streetNumber, renderHeader }) => (
  <Formik initialValues={{ streetNumber }} onSubmit={saveStreetNumber} validationSchema={schemas.streetNumber}>
    {({ handleSubmit, isSubmitting }) => (
      <Modal
        header={renderHeader ? renderHeader({ handleBack, handleClose, title: 'Delivery Address' }) : undefined}
        handleBack={handleBack}
        handleClose={handleClose}
        modalTitle="Delivery Address"
        open
        variant="side"
        hideBottomDecal={false}
        buttons={{
          primary: (
            <Button
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
              isLoading={isSubmitting || undefined}
              size="tall"
              isFullWidth
              widthType="fullWidth"
            >
              Confirm address
            </Button>
          ),
        }}
      >
        <Flex flexDirection="column" gap={{ xs: '24px', md: '32px' }} height="100%">
          <Flex flexDirection="column" gap="12px" width="100%">
            <P variant="small-semi-bold">Delivery address</P>
            <Flex width="100%" gap="8px">
              <Icon name="locationMarker" fill="black" />
              <Flex flexDirection="column" flex="1" overflow="hidden">
                <P variant="standard" color="black">
                  {address}
                </P>
              </Flex>
            </Flex>
          </Flex>
          <Box>
            <FormikTextInput required name="streetNumber" label="Street Number" autoFocus />
          </Box>
          {!!streetNumber && (
            <Box>
              <Alert type="info">
                We had a problem locating your exact address. Please confirm your street address number
              </Alert>
            </Box>
          )}
        </Flex>
      </Modal>
    )}
  </Formik>
);

ValidateStreetNumber.propTypes = {
  saveStreetNumber: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  streetNumber: PropTypes.string,
  renderHeader: PropTypes.func,
};

ValidateStreetNumber.defaultProps = {
  streetNumber: '',
  renderHeader: null,
};

export { ValidateStreetNumber };
